import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavService } from 'src/app/providers/nav.service';
import { isEmptyObject } from 'jquery';
// import { ApiService } from 'src/app/providers/api.service';
// import { ToastrService } from 'ngx-toastr';
import { iif, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/internal/operators';
// import { CommonService } from 'src/app/providers/common.service';
import { pageFilters, SharedService } from 'src/app/shared.service';
// import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../providers/common.service';
import { SideBarToolTip } from '../../shared.service';
import {transformAll} from '@angular/compiler/src/render3/r3_ast';
import {formatCurrency} from '@angular/common';

@Component({
  selector: 'app-sidebarfilters',
  templateUrl: './sidebarfilters.component.html',
  styleUrls: ['./sidebarfilters.component.css']
})
export class SidebarfiltersComponent implements OnInit {
  @Input() filterType: any;
  demo: any;

  @Output() getFiltersData = new EventEmitter<any>();

  @Input() gameStyleInitialId: any;

  @Input() selectedSlateId: any;

  @Input() selectedCategoryName: any;

  someRange = [0, 100000.00];

  filters: any = {
    sportId: '1',
    Position: '',
    Teams: '',
    excludehighlow: '0',
    typedisplay: '1',
    ha: '',
    player_type: 'pitching',
    recordType: 'game',
    categoryName: '',
    salaryRange: '0, 100000.00',
    limit: this.sharedService.defaultLimit,
    players: []
  };

  players = [];
  format = {
    to: (val) => {
      val = val.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      });
      if (val.split('.')) {
        val = val.split('.')[0]
      }
      return val;
    },
    from: (value) => {
      value = value.replace('$', '')
      if (value.split('.')) {
        value = value.split('.')[0]
      }
      value = value.replace(/[^0-9]/g,'');
      value = parseFloat(value)
      return value;
  }
  }

  addPlayerList: any = { players: [{ player_id: '', opp: '', ha: '' }] };
  // addPlayerList: any = [];
  Selectedplayers = [];
  numberOfPlayersList: string[] = [''];
  txtQueryChanged: Subject<string> = new Subject<string>();

  excludeHighLow = false;


  halist = [
    { name: 'Home', type: 'h' },
    { name: 'Away', type: 'a' },
    { name: 'Both', type: '' },
  ];

  isRangeChange = false;
  isShowFilter = true;

  @Output() sideFilterShow = new EventEmitter<any>();

  minValue = 0;
  maxValue = 100000.00;
  minLabel = Intl.NumberFormat().format(0);
  maxLabel = Intl.NumberFormat().format(100000);
  min = 0;
  max = 100000;

  _resetFilterType: number;
  get resetFilterType(): number {
    return this._resetFilterType;
  }

  @Input('resetFilterType')
  set resetFilterType(value: number) {
    this._resetFilterType = value;
    if (this._resetFilterType == pageFilters.chalkBoard || this._resetFilterType == pageFilters.myManager) {
      this.onResetBoardFilters(false);
    }
    if (this._resetFilterType == pageFilters.trends) {
      this.onResetTrendsFilter();
    }
    if (this._resetFilterType == pageFilters.last5) {
      this.onResetLast5Filters();
    }
  }

  loginUserDetails: any = JSON.parse(localStorage.getItem('userDetails'));

  teamSettings = {
    singleSelection: true,
    idField: 'team_id',
    textField: 'team_code',
    enableCheckAll: true,
    allowSearchFilter: false,
    selectAllText: 'All Teams',
    unSelectAllText: 'UnSelect All',
    // clearSearchFilter: true,
    maxHeight: 197,
    itemsShowLimit: 3,
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false
  };
  selectedTeamList = [];
  SideBarToolTip = new SideBarToolTip();
  positionSettings = {
    singleSelection: true,
    idField: 'position_name',
    textField: 'position_name',
    enableCheckAll: true,
    allowSearchFilter: false,
    selectAllText: 'All Positions',
    unSelectAllText: 'UnSelect All',
    // clearSearchFilter: true,
    maxHeight: 197,
    itemsShowLimit: 3,
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false
  };
  selectedPositionList = [];
  salarySet = false;
  _initialFiltersData: any;
  get initialFiltersData(): any {
    return this._initialFiltersData;
  }

  @Input('initialFiltersData')
  set initialFiltersData(value: any) {
    let isSportsChanged = false;
    if ( this.filters.sportId != this.commonService.platformandsport.sport_id.toString() ) {
      isSportsChanged = true;
    }
    this.filters.sportId = this.commonService.platformandsport.sport_id.toString();

    this._initialFiltersData = value;
    if (this._initialFiltersData && this._initialFiltersData.salaryRange) {
      if ((this._initialFiltersData.salaryRange[0].min_salary != null && this.min != this._initialFiltersData.salaryRange[0].min_salary)
        || ( this._initialFiltersData.salaryRange[0].max_salary != null && this.max != this._initialFiltersData.salaryRange[0].max_salary)) {
        this.min = this._initialFiltersData.salaryRange[0].min_salary;
        this.max = this._initialFiltersData.salaryRange[0].max_salary;
        this.minValue = this.min;
        this.maxValue = this.max;
        this.someRange = [this.min, this.max];
        this.salarySet = true;
      } else if (this._initialFiltersData.salaryRange[0].min_salary == null || this._initialFiltersData.salaryRange[0].max_salary == null) {
        this.minValue = 0;
        this.maxValue = 100000.00;
        this.someRange = [this.minValue, this.maxValue];
        this.salarySet = true;
      }

      this.minLabel = Intl.NumberFormat().format(this.minValue);
      this.maxLabel = Intl.NumberFormat().format(this.maxValue);
    } else {
      this.minValue = 0;
      this.maxValue = 100000.00;
      this.someRange = [this.minValue, this.maxValue];
      this.minLabel = Intl.NumberFormat().format(this.minValue);
      this.maxLabel = Intl.NumberFormat().format(this.maxValue);
      this.salarySet = true;
    }
    if (isSportsChanged) {
      this.onResetBoardFilters(true);
    }
  }

  constructor(
    private nav: NavService,
    // private api: ApiService,
    // private SpinnerService: NgxSpinnerService,
    // private toastr: ToastrService,
    public commonService: CommonService,
    public sharedService: SharedService,
  ) {

    this.txtQueryChanged
      .pipe(debounceTime(1000), // wait 1 sec after the last event before emitting last event
        distinctUntilChanged()) // only emit if value is different from previous value
      .subscribe(model => {
        // console.log('range' + model);
        const range = model[0] + ',' + model[1];
        this.filters.salaryRange = range;
        if (this.isRangeChange) {
          this.sendSelectedFiltersdata();
        }
      });
    this.filters.sportId = this.commonService.platformandsport.sport_id.toString();
  }



  ngOnInit() {
    this.filters.categoryName = this.selectedCategoryName;

    let userDetail = JSON.parse(localStorage.getItem('userDetails'));
    if (userDetail) {
      if(userDetail.fieldType !== undefined){
        this.filters.player_type =  userDetail.fieldType;
      }else{
        this.filters.player_type = this.filters.player_type ? this.filters.player_type : 'pitching';
      }
    }


    // if (this.gameStyleInitialId && this.selectedSlateId) {
    //   const getPlatfromSportId = this.commonService.getPlatformandSport();
    //   console.log("PS_ID :" + getPlatfromSportId);
    //   console.log("slateId :" + this.selectedSlateId);
    //   const data = {
    //     platform_id: getPlatfromSportId.platform.toString(),
    //     sport_id: getPlatfromSportId.sport.toString(),
    //     slates_id: this.selectedSlateId.toString()
    //   }
    //   this.playersList(data);
    // }


    // this.nav.navPlayerObj$.subscribe(item => {
    //   if (!isEmptyObject(item)) {
    //     const getPlatfromSportId = this.commonService.getPlatformandSport();
    //     const slateId = item;
    //     console.log("PS_ID :" + getPlatfromSportId);
    //     console.log("slateId :" + slateId);
    //     const tempData = {
    //       platform_id: getPlatfromSportId.platform.toString(),
    //       sport_id: getPlatfromSportId.sport.toString(),
    //       slates_id: slateId.toString()
    //     }
    //     this.addPlayerList = { players: [{ player_id: "", opp: "", ha: 'h' }] }
    //     this.playersList(tempData);
    //   } else {
    //     this.players = [];
    //   }
    // });

    this.nav.navPlatformSportObj$.subscribe(item => {
      if (!isEmptyObject(item)) {

        this.filters.Position = '';
        this.filters.Teams = '';
        this.filters.ha = '';
        this.excludeHighLow = false;
        this.filters.typedisplay = '1';
        this.someRange = [0, 100000.00];
      }
    });
  }

  userToSignup() {
    if (!this.loginUserDetails.isLogin) {
      this.sharedService.userToSignup();
    }
  }


  // playersList(item){
  //   this.SpinnerService.show();
  //   this.api.playerTeamList(item).subscribe(data => {
  //     this.SpinnerService.hide();
  //     if (data && data.code == 100) {
  //       this.players = data.data.playerTeamList;
  //       this.addPlayerList.players[0].player_id = this.players[0].player_id;
  //       console.log(data.message);
  //     }else{
  //       console.log(data.message);
  //     }
  //   }, (err) => {
  //     this.SpinnerService.hide();
  //     console.log("Somthing went wrong");
  //   });
  // }


  changeTypeHaTrends(event) {
    this.filters.ha = event.target.value;
  }

  onAddPlayerList() {
    if (this.addPlayerList.players.length != 5) {
      const emptyPlayerData = { player_id: '', opp: '', ha: '' };
      this.addPlayerList.players.push(emptyPlayerData);
      // console.log(this.addPlayerList);
      // const tempPlayer = '';
      // this.numberOfPlayersList.push(tempPlayer);
    } else {
      alert('limit over');
    }
  }

  onClosePlayer(item, index) {
    // console.log('clicked' + item);
    this.addPlayerList.players.splice(index, 1);
    // console.log(this.addPlayerList);
  }

  trackByFn(index, item) {
    return index;
  }


  // changePlayersData(slateid, type) {
  //   this.filters.slate = '';
  //   if (slateid == '') {
  //     this.players = [];
  //   } else {
  //     if (this.initialFiltersData && this.initialFiltersData.gameStyleList) {
  //       this.initialFiltersData.gameStyleList.forEach(element => {
  //         if (slateid == element.game_style_id && element.slates.length > 0) {
  //           this.players = element.slates;
  //         }
  //       });
  //     }
  //   }

  //   this.sendSelectedFiltersdata();
  // }

  onExclude(event) {
    if (event.target.checked) {
      this.filters.excludehighlow = '1';
    } else {
      this.filters.excludehighlow = '0';
    }

    this.sendSelectedFiltersdata();
  }

  changeTypeDisplay(event) {
    this.filters.typedisplay = event.target.value;
    this.sendSelectedFiltersdata();
  }

  changeTypeHA(event) {
    this.filters.ha = event.target.value;
    this.sendSelectedFiltersdata();
  }

  changePlayerType(event) {
    this.filters.player_type = '';
    this.filters.player_type = event.target.value;
    let userDetail = JSON.parse(localStorage.getItem('userDetails'));
    if (userDetail) {
      userDetail['fieldType'] = event.target.value;
      localStorage.setItem('userDetails', JSON.stringify(userDetail));
    }
    /*Empty selected player list*/
    this.selectedPositionList = [];
    this.sendSelectedFiltersdata();
  }
  changeCategory(event) {
    this.filters.categoryName = '';
    this.filters.categoryName = event.target.value;
    this.getFiltersData.emit(this.filters);
  }

  sendSelectedFiltersdata(event: any = null) {
    this.filters.Teams = '';
    if (this.selectedTeamList && this.selectedTeamList.length > 0) {
      this.filters.Teams = this.selectedTeamList.map(m => m.team_code).join(',');
      if (event && event._placeholder == 'All Teams' && event.selectedItems.length == this.initialFiltersData.teamList.length) {
        event.selectedItems = [];
      }
    }
    if (this.selectedPositionList && this.selectedPositionList.length > 0) {
      this.filters.Position = this.selectedPositionList.map(m => m.position_name).join(',');
      if (event && event._placeholder == 'All Positions' && event.selectedItems.length == this.initialFiltersData.positionList.length) {
        event.selectedItems = [];
      }
    }else{
      this.filters.Position = '';
    }
    this.filters.sportId = this.commonService.platformandsport.sport_id.toString();
    this.getFiltersData.emit(this.filters);
  }

  onResetBoardFilters(isSportChanged?:any) {
    this.filters = {
      Position: '',
      Teams: '',
      excludehighlow: '0',
      typedisplay: '1',
      ha: '',
      player_type: '',
      salaryRange: this.min + ', ' + this.max,
    };
    if(this.loginUserDetails.fieldType !== undefined){
      this.filters.player_type =  this.loginUserDetails.fieldType;
    }else{
      this.filters.player_type = this.filters.player_type ? this.filters.player_type : 'pitching';
    }

    this.excludeHighLow = false;
    this.selectedTeamList = [];
    this.selectedPositionList = [];
    this.someRange = [this.min, this.max];
    this.isRangeChange = false;
    if (!isSportChanged) {
    this.sendSelectedFiltersdata();
    }
  }

  onResetTrendsFilter() {
    this.filters = {
      playerId: '',
      Teams: '',
      excludehighlow: '0',
      typedisplay: '3',
      ha: '',
      category_name: '',
      recordType: 'game'
    };
    this.sendSelectedFiltersdata();
  }

  onResetLast5Filters() {
    this.filters.Position = '';
    this.filters.salaryRange = this.min + ', ' + this.max;
    this.someRange = [this.min, this.max];
    this.sendSelectedFiltersdata();
  }

  sendAllPositionsFiltersdata(event) {
    this.filters.Position = '';
    this.selectedPositionList = [];
    this.getFiltersData.emit(this.filters);
    event.selectedItems = [];
  }
  sendAllTeamFiltersdata(event) {
    this.filters.Teams = '';
    this.selectedTeamList = [];
    this.getFiltersData.emit(this.filters);
    event.selectedItems = [];
  }

  onSubmitTrendsFilter() {
    // console.log(this.addPlayerList);
    this.filters.players = this.addPlayerList;
    this.sendSelectedFiltersdata();
  }

setSalary(){
  this.salarySet = false;
}
  rangeChanged(query) {
    let changeVal = true;
    if (this.minValue == query[0] && this.maxValue == query[1]) {
      changeVal = false;
    }
    this.minValue = query[0];
    this.maxValue = query[1];
    this.minLabel = Intl.NumberFormat().format(this.minValue);
    this.maxLabel = Intl.NumberFormat().format(this.maxValue);
    if (changeVal && !this.salarySet) {
      this.isRangeChange = true;
      this.txtQueryChanged.next(query);
    }
  }

  changeShowFilter() {
    this.isShowFilter = !this.isShowFilter;
    this.sideFilterShow.emit(this.isShowFilter);
  }

  minMaxValueChange(isMinChange) {
    if (isMinChange) {
      if (this.minValue < 0 || this.minValue > this.maxValue) {
        this.minValue = 0;
      }
    } else {
      if (this.maxValue > 100000.00 || this.maxValue < this.minValue) {
        this.maxValue = 100000.00;
      }
    }
    this.minLabel = Intl.NumberFormat().format(this.minValue);
    this.maxLabel = Intl.NumberFormat().format(this.maxValue);
    const tmp = [];
    tmp[0] = this.minValue;
    tmp[1] = this.maxValue;
    this.someRange = tmp;
    this.rangeChanged(tmp);
  }

}
